module.exports = __webpack_public_path__ + "img/3.96a82477.png";